(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.recommended');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.recommended');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  $( document )
  .on(`click`, `.product-sizes__option`, function( e ) {
    try {

      e.stopImmediatePropagation();

      const card    =   $( this ).closest( `.set` );
      card.find( `.product-sizes .product-sizes__option` ).removeClass( `selected` );

      $( this ).addClass( `selected` );

      let getObject     =   card.find( `textarea` ).val();

      getObject          =   JSON.parse( getObject );

      let selectedVariant;

      if ( getObject.totalOptions == 1 ) {

        const getFirstSelectVal     =   $( this ).find( `span` ).text().trim();

        selectedVariant             =   findObjectByKey( getObject.variants, 'vTitle', getFirstSelectVal );

      }

      // console.log ( 'selectedVariant', selectedVariant );

      if ( typeof selectedVariant !== 'undefined' && selectedVariant ) {

        const getProductURL         =   card.attr( `url` );

        card.find( `.set__info h2 a, .set__image > a` ).attr( `href`, `${ getProductURL }?variant=${ selectedVariant.vid }` );

      }

    }
    catch ( err ) {
      console.log( `ERROR .product-sizes__option`, err.message );
    }
  })

  .on(`click`, `.product-variants__variant`, function( e ) {
    try {

      e.stopImmediatePropagation();

      const card    =   $( this ).closest( `.set` );
      card.find( `.product-variants .product-sizes__option` ).removeClass( `selected` );

      $( this ).addClass( `selected` );

      let getObject     =   card.find( `textarea` ).val();

      getObject          =   JSON.parse( getObject );

      let selectedVariant;

      if ( getObject.totalOptions == 1 ) {

        const getFirstSelectVal     =   card.find( `.product-sizes .product-sizes__option.selected span` ).text().trim();

        selectedVariant             =   findObjectByKey( getObject.variants, 'vTitle', getFirstSelectVal );

      }

      // console.log ( 'selectedVariant', selectedVariant );

      if ( typeof selectedVariant !== 'undefined' && selectedVariant ) {

        const getProductURL         =   $( this ).closest( `.product-variants__variant` ).attr( `handle` );

        card.find( `.set__info h2 a` ).attr( `href`, `/products/${ getProductURL }?variant=${ selectedVariant.vid }` );

        card.find( `.set__info .set__price` ).text( `${ selectedVariant.vPriceSymbol }${ selectedVariant.vPrice }` );

      }

    }
    catch ( err ) {
      console.log( `ERROR .product-variants__variant`, err.message );
    }
  })
  ;

  } catch(e) { console.error(e); }
})();
})();
